import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dscr-calculator',
  component: () => import('../../routes/DscrCalculator.svelte'),
  card: {
    id: 'dscr-calculator',
    title: 'DSCR Calculator',
    description: 'Calculate Debt Service Coverage Ratio (DSCR) for rental properties. See if your property income covers its mortgage and meets commercial lender requirements.',
    icon: 'analytics',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/dscr-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'DSCR Calculator – Debt Service Coverage Ratio for Rental Properties',
    description:
      'Free DSCR calculator for real estate investors. Calculate whether your rental property income covers its mortgage payments. Includes lender requirement guidance (1.25 minimum).',
  },
};

export default meta;